import { createAction } from 'redux-actions';
import getApplicationName from 'ui-forms-editor-automation-lib/selectors/parentApplication/getApplicationName';
import APPLICATION_NAMES from 'ui-forms-editor-automation-lib/constants/APPLICATION_NAMES';
import getGuid from 'ui-forms-editor-automation-lib/selectors/getGuid';
import getFormDependencies from 'ui-forms-editor-automation-lib/api/getFormDependencies';
import SOURCE_APP from 'ui-forms-editor-automation-lib/constants/SOURCE_APP';
export const REQUEST_FORM_DEPENDENCIES = '@@lib/REQUEST_FORM_DEPENDENCIES';
export const RECEIVE_FORM_DEPENDENCIES = '@@lib/RECEIVE_FORM_DEPENDENCIES';
export const FAIL_RECEIVE_FORM_DEPENDENCIES = '@@lib/FAIL_GETTING_FORM_DEPENDENCIES';
const requestFormDependencies = createAction(REQUEST_FORM_DEPENDENCIES);
const receiveFormDependencies = createAction(RECEIVE_FORM_DEPENDENCIES);
const failGettingFormDependencies = createAction(FAIL_RECEIVE_FORM_DEPENDENCIES);
export const fetchFormDependencies = (providedGuid, providedSourceApp) => (dispatch, getState) => {
  const state = getState();
  const guid = providedGuid || getGuid(state);
  let sourceApp = providedSourceApp;
  if (!sourceApp) {
    const applicationName = getApplicationName(state);
    switch (applicationName) {
      case APPLICATION_NAMES.LEADFLOWSUI:
        sourceApp = SOURCE_APP.LEAD_FLOWS_APP;
        break;
      case APPLICATION_NAMES.FORMSUI:
      default:
        sourceApp = SOURCE_APP.FORMS_APP;
        break;
    }
  }
  dispatch(requestFormDependencies());
  return getFormDependencies(guid, sourceApp).then(formDependencies => {
    return dispatch(receiveFormDependencies(formDependencies));
  }).catch(error => {
    dispatch(failGettingFormDependencies(error));
  });
};